"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconFuelSourceFlexibility = function IconFuelSourceFlexibility(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m24 5.33 2.79 4.83H25v13.17h-2V10.16h-1.79zm-18 19 4.84-2.79v1.79h7.177a8.57 8.57 0 0 1 5.413 2.045l.247.22-1.354 1.47a6.57 6.57 0 0 0-4.025-1.723L18 25.33h-7.16v1.79zm36 0-4.84-2.79v1.79H31l-.264.021c-4.198.4-7.459 3.741-7.734 7.913L23 43.33h2v-12l.02-.232c.32-3.086 2.867-5.56 6.046-5.77l6.094.002v1.79z",
    clipRule: "evenodd"
  })));
};

export { IconFuelSourceFlexibility, IconFuelSourceFlexibility as default };
